import { urlToB64 } from '../../src/imageUtils';

export const webViewCanvasCommands = {
	loaded: 'loaded',
	close: 'close',
	save: 'save',
	update: 'update',
};

const b64EncodeKeys = ['sketch'];
const JSONEncodeKeys = [
	'analysisDataFront',
	'analysisDataBack',
	'eoc',
	'condition',
	'bodySite',
];

export const webViewCanvasRunFirst = async (props) => {
	if(!props) return;
	let res = '';
	for (const key of Object.keys(props)) {
		const value = props[key];
		if(!value) continue;
		const processedValue = b64EncodeKeys.includes(key) ? await urlToB64(value)
			: JSONEncodeKeys.includes(key) ? encodeURIComponent(JSON.stringify(value))
				: value;
		res += (`
            const is${key}Div = document.getElementById("${key}Div");

            if (!is${key}Div) {
                const ${key}Div = document.createElement("div");
                ${key}Div.innerText = "${processedValue}";

                ${key}Div.style.height = "0px";
                ${key}Div.style.width = "0px";

                ${key}Div.id = "${key}Div";
                document.body.appendChild(${key}Div);
            }
            `
		);
	}
	res += 'true; // note: this is required, or you\'ll sometimes get silent failures';
	return res;
};